import { PiCheckCircleFill } from "react-icons/pi";

export const CheckIcon = () => (
  <PiCheckCircleFill className="text-2xl text-green-600 md:text-3xl" />
);
